import React from 'react';
import SettingsTemplate from './SettingsTemplate';
var SettingsPage = function(param) {
    var user = param.user, sections = param.sections, onItemClick = param.onItemClick, onToggleChange = param.onToggleChange, onEditProfile = param.onEditProfile, onEditEmail = param.onEditEmail, onEditPhone = param.onEditPhone, onLogout = param.onLogout, headerCustomComponent = param.headerCustomComponent, footerCustomComponent = param.footerCustomComponent;
    return /*#__PURE__*/ React.createElement(SettingsTemplate, {
        user: user,
        sections: sections,
        onItemClick: onItemClick,
        onToggleChange: onToggleChange,
        onEditProfile: onEditProfile,
        onEditEmail: onEditEmail,
        onEditPhone: onEditPhone,
        onLogout: onLogout,
        headerCustomComponent: headerCustomComponent,
        footerCustomComponent: footerCustomComponent
    });
};
export default SettingsPage;
